import { render } from "./callView.vue?vue&type=template&id=af8e031c"
import script from "./callView.vue?vue&type=script&lang=js"
export * from "./callView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__